



























import { Vue, Component, Prop } from "vue-property-decorator";
import User, { countUserWithRole, Role } from "@/data/models/User";
import {
getRoleActive,
  getRoleDescription,
  getRoleId,
  getRoleLabel,
  RoleSettings,
} from "@/data/models/RoleSettings";

@Component({
  components: {},
})

export default class RoleItemNonClickableComponent extends Vue {
  @Prop() role!: Role;
  @Prop() roleSettings!: RoleSettings;
  @Prop() users!: User[];
  @Prop() alwaysActivateRole!: boolean;

  get roleLabel() {
    return getRoleLabel(this.role, this);
  }

  get roleId() {
    return getRoleId(this.role);
  }

  get countUserWithRole() {
    return countUserWithRole(this.role);
  }

  get roleActive() {
    return this.alwaysActivateRole || getRoleActive(this.role, this);
  }

  get roleDescription() {
    return getRoleDescription(this.role, this);
  }
}
